module.exports = __webpack_public_path__ + "img/logo_4_white.b8f40327.svg";